/**
 * Check if a string is plain text (no HTML tags)
 */
export function isPlainText(value: string): boolean {
  return !/<[a-z][\s\S]*>/i.test(value)
}

/**
 * Strip all HTML tags, returning plain text. Tags become spaces so adjacent
 * block elements don't glue words together ("<p>Hi!</p><p>I'm" -> "Hi! I'm").
 */
export function stripHtml(html: string): string {
  return html
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/\s+/g, ' ')
    .trim()
}

/**
 * Escape HTML special characters in plain text
 */
export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

/**
 * Normalize bio content for the editor.
 * Converts plain text (legacy) to HTML paragraphs.
 * Passes through existing HTML as-is.
 */
export function normalizeBio(value: string | null): string {
  if (!value) return ''
  if (!isPlainText(value)) return value

  return value
    .split('\n')
    .filter(line => line.trim() !== '')
    .map(line => `<p>${escapeHtml(line)}</p>`)
    .join('')
}
